import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@components/SvgIcon';

const IconRY = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M7.5 10a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5zm0-12a.5.5 0 01.5.5V.05C9.878.244 11.515.967 12.602 2H10.33c-.633-.443-1.434-.765-2.328-.911L8 3.5a.5.5 0 01-1 0L7.001 1H6.9C4.194 1 2 2.567 2 4.5S4.194 8 6.9 8c1.955 0 3.642-.818 4.429-2H9V4h6v6h-2V7.576C11.777 9.028 9.548 10 7 10c-3.866 0-7-2.239-7-5s3.134-5 7-5v-1.5a.5.5 0 01.5-.5z"
          id="s-ry_svg__a"
        />
      </defs>
      <g transform="translate(1 3)" fill="none" fillRule="evenodd">
        <mask id="s-ry_svg__b" fill="#fff">
          <use xlinkHref="#s-ry_svg__a" />
        </mask>
        <use fill="#D8D8D8" xlinkHref="#s-ry_svg__a" />
        <path fill={color} mask="url(#s-ry_svg__b)" d="M-5-7h25v25H-5z" />
      </g>
    </>
  ),
})``;

export default IconRY;
